import _ from 'lodash';
import moment from 'moment/moment';
import dateHelper from '$$dateFormatsHelper';

function getWeekScale() {
  return {
    unit: 'week',
    step: 1,
    index: 1,
    template(ndate) {
      const nday = ndate.getDay();
      const first_thursday = new Date(ndate.valueOf());

      first_thursday.setDate(ndate.getDate() + (4 - nday));

      const year_number = first_thursday.getFullYear(); // year of the first Thursday
      const ordinal_date = Math.round((first_thursday.getTime() - new Date(year_number, 0, 1).getTime()) / 86400000); // ordinal date of the first Thursday - 1 (so not really ordinal date)
      const week_number = 1 + Math.floor(ordinal_date / 7);

      const startDateDay = ndate.getDate();
      const endDate = ndate;

      endDate.setDate(endDate.getDate() + 6);
      const endDateDay = endDate.getDate();

      return `<span title="${__('days_week_range')}">${startDateDay}-${endDateDay}</span>&nbsp;<span title="${__('week_number')}">(${week_number}${__('week_in_time_string')})</span>`;
      // return week_number + " " + __('gantt_week');
    },
  };
}

export default function (instance) {
  const locale = user.locale;
  let dayFormatForHour = locale === 'en' ? '%M %d' : '%d %M';
  const currentCalendar = instance.getCalendar(instance.config.gantt_id);
  const endTimeForHour = currentCalendar._worktime.parsed.hours;
  const lastEndHour = endTimeForHour.reduce((maxEndHour, data) => (data.endHour > maxEndHour ? data.endHour : maxEndHour), -Infinity);
  const isShowDaysOnChart = instance.config.show_days_on_chart && !instance.config.isWorkload;

  if (instance.config.show_days_on_chart) {
    dayFormatForHour = locale === 'en' ? '%D, %M %d' : '%D, %d %M';
  }

  return {
    levels: [
      {
        name: 'hour',
        scale_height: 38,
        min_column_width: 20,
        scales: [
          {
            unit: 'day',
            step: 1,
            format: dayFormatForHour,
          },
          {
            unit: 'hour',
            step: 1,
            format: !dateHelper.getUserTimeFormat() ? '%h' : '%H',
            css(date) {
              if (date.getHours() + 1 === lastEndHour) {
                return ' end-day';
              }

              return '';
            },
          },
        ],
      },
      {
        name: 'day',
        scale_height: isShowDaysOnChart ? 48 : 38,
        min_column_width: 26,
        scales: [
          {
            unit: 'month',
            step: 1,
            date: '%F %Y',
            customHeight: 18,
            css() {
              return isShowDaysOnChart ? ' fixed-first-scale-height' : '';
            },
          },
          {
            unit: 'day',
            step: 1,
            date: isShowDaysOnChart ? '%d %W' : '%d',
            customHeight: isShowDaysOnChart ? 29 : 19,
            css(date) {
              if (!instance.isWorkDay(date)) {
                if (isShowDaysOnChart) {
                  return ' fixed-second-scale-height weekend';
                }

                return ' weekend';
              }

              return '';
            },
            template(date) {
              if (isShowDaysOnChart) {
                const dayOfWeek = date.toLocaleString(locale, { weekday: 'short' })[0];

                return `<div class="date-day-wrap"> <div  class="date-wrap">${instance.date.date_to_str('%d')(date)}</div><div  class="day-wrap"> ${dayOfWeek.toUpperCase()}</div></div>`;
              }

              return `${instance.date.date_to_str('%d')(date)}`;
            },
          },
        ],
      },
      {
        name: 'week',
        scale_height: 38,
        min_column_width: 70,
        scales: [
          { unit: 'month', step: 1, date: '%F %Y' },
          getWeekScale(),
        ],
      },
      {
        name: 'month',
        scale_height: 38,
        min_column_width: 65,
        scales: [
          { unit: 'year', step: 1, format: '%Y' },
          { unit: 'month', step: 1, format: '%M' },
        ],
      },
      {
        name: 'quarter',
        height: 38,
        min_column_width: 45,
        scales: [
          { unit: 'quarter', step: 1, format: date => `${__('settings_quarter')} ${Math.ceil((date.getMonth() + 1) / 3)}, ${date.getFullYear()}` },
          { unit: 'month', step: 1, format: '%M' },
        ],
      },
      {
        name: 'year',
        scale_height: 38,
        min_column_width: 45,
        scales: [
          { unit: 'year', step: 1, format: '%Y' },
        ],
      },
    ],
  };
}
